import React from "react";
import { useNavigate } from 'react-router-dom';

import { FaHome } from "react-icons/fa";
import { SiReaddotcv } from "react-icons/si";
import { GiHammerNails } from "react-icons/gi";

import "../styles/Sidebar.css";
import "../styles/mobile/Sidebar.css"
import { useSidebar } from "./SidebarContext.jsx";

const preloadMap = {
  '/': () => import('../src/Homepage.jsx'),
  '/resume': () => import('../src/Resume.jsx'),
};

const Sidebar = () => {
  const { isSidebarOpen } = useSidebar();

  return (
    <div className={`floating-sidebar ${isSidebarOpen ? 'active' : ''}`}>
      <SidebarIcon icon={<FaHome className="sidebarIconImg" />} label="Home" link="/"/>
      <SidebarIcon icon={<SiReaddotcv className="sidebarIconImg" />} label="Profile" link="/resume" />
      <SidebarIcon icon={<GiHammerNails className="sidebarIconImg" />} label="Projects" link="/projects" />
    </div>
  );
};

const SidebarIcon = ({ icon, label, link }) => {
  const navigate = useNavigate();
  const { setSidebarOpen } = useSidebar();

  const handleClick = (e) => {
    e.preventDefault();
    setSidebarOpen(false);

    // Start a view transition when navigating
    if (document.startViewTransition) {
      document.startViewTransition(() => {
        navigate(link);
      });
    } else {
      navigate(link);
    }
  };

  return (
    <a className="sidebar-icon" href={link} onClick={handleClick}
      onMouseEnter={() => {
      if (preloadMap[link]) preloadMap[link]();
      }}>
        {icon}
        <span className="tooltip">{label}</span>
    </a>
  )
};

export default Sidebar;